export default __webpack_public_path__ + "media/images/white-green-pattern-07854ea06663e5f2f159fe56b5679405.PNG";